import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { space } from '@synoptic/ui-kit/tokens.js';
import { typography } from '@synoptic/ui-kit/typography.js';
import { style } from '../layer.css';
import { comboboxMenuItem } from './multi-select-combobox.css';

export const multiSelectMenuContainer = style({
  display: 'flex',
  flexDirection: 'column',
  gap: space.s8,
  padding: space.s16,
  overflow: 'auto',
});

export const multiSelectMenu = style({
  display: 'flex',
  flexDirection: 'column',
  gap: space.s4,
  margin: 0,
  marginLeft: -space.s8,
  marginRight: -space.s8,
  padding: 0,
});

export const multiSelectMenuItem = style([
  comboboxMenuItem,
  {
    cursor: 'pointer',
    ':hover': {
      backgroundColor: themeVars.dropdownMenu.background.hover,
    },
  },
]);

export const multiSelectMenuItemDisabled = style([
  comboboxMenuItem,
  {
    cursor: 'not-allowed',
  },
]);

export const multiSelectMenuGroupTitle = style([
  typography.labelMd,
  {
    display: 'block',
    color: themeVars.color.text.tertiary,
    paddingBottom: space.s2,
  },
]);

export const loadingContainer = style({
  height: 32,
  display: 'flex',
  alignItems: 'center',
});

export const emptyDropdownPlaceholder = style({
  ...typography.bodySm,
  color: themeVars.color.text.tertiary,
});
